import ActorsListComponent from './ActorsListComponent';

export default ActorsListComponent;
